import React, { useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const tabs = [
  { label: "Blogs", to: "/blogs" },
  { label: "Events", to: "/events" },
  { label: "Plans", to: "/plans" },
  { label: "Cities", to: "/things-to-do" },
  { label: "Communities", to: "/communities" },
];

const SiteHeader = () => {
  // A single event's page (/event/...) sits under the Events tab.
  const { pathname } = useLocation();
  const onEventPage = pathname.startsWith("/event/");
  const onPlanPage = pathname.startsWith("/plan/");
  // On phones the tab bar scrolls; keep the current tab in view.
  const nav = useRef(null);
  useEffect(() => {
    const bar = nav.current, tab = bar?.querySelector(".site-tab-active");
    if (bar && tab && bar.scrollWidth > bar.clientWidth) bar.scrollLeft = tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2;
  }, [pathname]);
  return (
    <header className="site-header">
      <Link className="site-brand" to="/" aria-label="Blox home">
        blox<span className="site-brand-dot">.</span>
      </Link>

      <nav className="site-tabs" aria-label="Main navigation" ref={nav}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            className={({ isActive }) =>
              `site-tab${isActive || (onEventPage && tab.to === "/events") || (onPlanPage && tab.to === "/plans") ? " site-tab-active" : ""}`
            }
            to={tab.to}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
};

export default SiteHeader;
